/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  SET_GROUPS,
  GET_GROUPS,
  GET_GROUPS_SUCCESS,
  GET_GROUPS_ERROR,
  SET_GROUPS_QUERY,
  CLEAR_GROUPS_QUERY_FILTER,
  SET_SELECTED_GROUPS,
  SET_VISIBLE_MODAL_FORM_NUMBER,
  SET_VALUES_FORM_SEND_TEXT,
  SEND_TEXT_MESSAGE,
  SEND_TEXT_MESSAGE_ERROR,
  SEND_TEXT_MESSAGE_SUCCESS,
  SET_VALUES_FORM_ADD_CATEGORY,
  SEND_ADD_CATEGORY,
  SEND_ADD_CATEGORY_ERROR,
  SEND_ADD_CATEGORY_SUCCESS,
  // SEND_ADD_GROUP,
  // SEND_ADD_GROUP_ERROR,
  // SEND_ADD_GROUP_SUCCESS,
  GET_FOLLOW_UP_MESSAGES,
  GET_FOLLOW_UP_MESSAGES_SUCCESS,
  GET_FOLLOW_UP_MESSAGES_ERROR,
  SET_BACK_TO_GROUP_LIST,
  GET_GROUP_TYPES,
  GET_GROUP_TYPES_SUCCESS,
  GET_GROUP_TYPES_ERROR,
  SEND_INACTIVATE_GROUPS,
  SEND_INACTIVATE_GROUPS_ERROR,
  SEND_INACTIVATE_GROUPS_SUCCESS,
} from 'src/actions/groupsActions';

const initialFilters = {
  groupType: null,
};

const formSendText = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const formAddCategory = {
  loading: false,
};

const followUpMessages = {
  followUpMessageList: [],
  loading: false,
};

const backToGroupList = {
  groups: [],
  query: {},
  active: false,
  comeBack: false,
};

const groupTypes = {
  groupTypeList: [],
  loading: false,
};

const initialState = {
  groups: [],
  selectedGroups: [],
  query: {
    search: '',
    filters: initialFilters,
    status: 'active',
    // CON-2026 — the "Unseen (N)" activity filter (ACTIVITY_BADGES holders).
    newOnly: false,
    sort: [],
    page: 1,
    pageSize: 50,
    count: 0,
  },
  visibleModalFormNumber: null,
  formSendText,
  formAddCategory,
  followUpMessages,
  backToGroupList,
  loading: false,
  groupTypes,
};

const groupsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_GROUPS: {
      return produce(state, (draft) => {
        draft.groups = payload || [];
        draft.selectedGroups = [];
      });
    }

    case GET_GROUPS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_GROUPS_SUCCESS: {
      return produce(state, (draft) => {
        draft.groups = payload?.groups || [];
        draft.query.count = payload?.total || 0;
        draft.loading = false;
        draft.selectedGroups = [];
      });
    }

    case GET_GROUPS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SET_GROUPS_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : initialState.query;
      });
    }

    case CLEAR_GROUPS_QUERY_FILTER: {
      return produce(state, (draft) => {
        draft.query.filters = initialFilters;
        draft.query.page = initialState.query.page;
      });
    }

    case SET_SELECTED_GROUPS: {
      return produce(state, (draft) => {
        draft.selectedGroups = payload || [];
      });
    }

    case SET_VISIBLE_MODAL_FORM_NUMBER: {
      return produce(state, (draft) => {
        draft.visibleModalFormNumber = payload || null;
      });
    }

    case SET_VALUES_FORM_SEND_TEXT: {
      return produce(state, (draft) => {
        draft.formSendText = payload ? {
          ...state.formSendText,
          ...payload,
        } : formSendText;
      });
    }

    case SEND_TEXT_MESSAGE: {
      return produce(state, (draft) => {
        draft.formSendText.loading = true;
      });
    }

    case SEND_TEXT_MESSAGE_SUCCESS:
    case SEND_TEXT_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.formSendText.loading = false;
      });
    }

    case SET_VALUES_FORM_ADD_CATEGORY: {
      return produce(state, (draft) => {
        draft.formAddCategory = payload ? {
          ...state.formAddCategory,
          ...payload,
        } : formAddCategory;
      });
    }

    case SEND_ADD_CATEGORY: {
      return produce(state, (draft) => {
        draft.formAddCategory.loading = true;
      });
    }

    case SEND_ADD_CATEGORY_SUCCESS:
    case SEND_ADD_CATEGORY_ERROR: {
      return produce(state, (draft) => {
        draft.formAddCategory.loading = false;
      });
    }

    case GET_FOLLOW_UP_MESSAGES: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = true;
      });
    }

    case GET_FOLLOW_UP_MESSAGES_SUCCESS:
    case GET_FOLLOW_UP_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = false;
        draft.followUpMessages.followUpMessageList = payload ? [
          ...state.followUpMessages.followUpMessageList,
          ...payload,
        ] : followUpMessages.followUpMessageList;
      });
    }

    case SET_BACK_TO_GROUP_LIST: {
      return produce(state, (draft) => {
        draft.backToGroupList = payload ? {
          ...state.backToGroupList,
          ...payload,
        } : backToGroupList;
      });
    }

    case GET_GROUP_TYPES: {
      return produce(state, (draft) => {
        draft.groupTypes.loading = true;
      });
    }

    case GET_GROUP_TYPES_SUCCESS:
    case GET_GROUP_TYPES_ERROR: {
      return produce(state, (draft) => {
        draft.groupTypes.loading = false;
        draft.groupTypes.groupTypeList = payload ? [
          ...state.groupTypes.groupTypeList,
          ...payload,
        ] : groupTypes.groupTypeList;
      });
    }

    case SEND_INACTIVATE_GROUPS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case SEND_INACTIVATE_GROUPS_SUCCESS:
    case SEND_INACTIVATE_GROUPS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default groupsReducer;
